import { render } from "./WangEditor.vue?vue&type=template&id=042200c0&scoped=true"
import script from "./WangEditor.vue?vue&type=script&lang=js"
export * from "./WangEditor.vue?vue&type=script&lang=js"

import "./WangEditor.vue?vue&type=style&index=0&id=042200c0&lang=less&scoped=true"

import exportComponent from "E:\\heguang\\bm365\\src\\manage\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-042200c0"]])

export default __exports__